module.exports = __webpack_public_path__ + "img/shield_1.0082f5e9.png";